/**
 * Encode/decode Power BI deep-link (reportId + rp:* params) for OAuth state
 * so the report opens after login even when the callback lands in a different tab/window.
 */
const STATE_PREFIX = 'pbi:';

export interface PowerBiDeepLinkState {
  reportId: string;
  reportParams?: Record<string, string | string[]>;
}

export function encodePowerBiDeepLinkState(payload: PowerBiDeepLinkState): string {
  try {
    return STATE_PREFIX + btoa(encodeURIComponent(JSON.stringify(payload)));
  } catch {
    return '';
  }
}

export function decodePowerBiDeepLinkState(state: string | undefined | null): PowerBiDeepLinkState | null {
  if (!state || typeof state !== 'string') return null;
  let raw = state;
  if (!raw.startsWith(STATE_PREFIX)) {
    try {
      raw = decodeURIComponent(raw);
    } catch {
      return null;
    }
  }
  if (!raw.startsWith(STATE_PREFIX)) return null;
  try {
    const json = decodeURIComponent(atob(raw.slice(STATE_PREFIX.length)));
    const parsed = JSON.parse(json) as PowerBiDeepLinkState;
    return parsed?.reportId ? parsed : null;
  } catch {
    return null;
  }
}
